import { useEffect } from 'react';

const VERSION_KEY = 'app_version';

export function useVersionCheck() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', {
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
          },
          cache: 'no-store',
        });

        if (!res.ok) return;

        const { version, buildTime } = await res.json();
        const serverVersion = `${version}_${buildTime}`;
        const storedVersion = localStorage.getItem(VERSION_KEY);

        if (storedVersion && storedVersion !== serverVersion) {
          localStorage.setItem(VERSION_KEY, serverVersion);
          window.location.reload();
          return;
        }

        localStorage.setItem(VERSION_KEY, serverVersion);
      } catch {
        // fail silently — don't break the app if version.json is unreachable
      }
    };

    checkVersion();
  }, []);
}
